import isEmpty from 'lodash/isEmpty';
import * as types from '../actionTypes/OrderActionTypes';

export default function OrderConfirmationReducer(state = [], action) {
    // NOSONAR
    switch (action.type) {
        case types.LAST_ORDER_GET_REQUEST_SUCCESS:
            return { ...action.orderDetails, orderNotFound: false };
        case types.LAST_ORDER_NOT_FOUND:
            return { ...state, orderNotFound: true };
        case types.CLEAR_RENDER_FROM:
            /* istanbul ignore else */
            if (isEmpty(state)) {
                return state;
            }
            /* istanbul ignore next */
            return { ...state, renderFrom: undefined };
        default:
            return state;
    }
}
